export default "__VITE_ASSET__sM6agrJ6GRDAt2xqS1b0OA__";